module.exports = __webpack_public_path__ + "static/media/b6.d5b3850.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sijie/b6.mp3
// module id = eoV8
// module chunks = 0